<template>
  <div id="LayoutAuth">
    <Row>
      <Column v-if="isDesktop" :lg="6" :md="5" :xl="7">
        <div class="LayoutAuth-side">
          <Pic class="banner" :formats="['webp']" src="/assets/img/bg/solar-bg.jpg" />
          <MainLogo format="png" type="white" />
        </div>
      </Column>
      <Column :lg="6" :md="7" :xl="5">
        <div class="LayoutAuth-container">
          <MainLogo v-if="!isDesktop" format="png" />
          <div class="view-container">
            <router-view />
          </div>
        </div>
      </Column>
    </Row>
  </div>
</template>

<script>
import MainLogo from '../components/navigation/MainLogo'
import { getters } from '../utils'

export default {
  components: { MainLogo },
  computed: getters('isDesktop'),
}
</script>

<style lang="scss">
$_hero-gradient-start: $fancy-darker;
$_hero-gradient-end: $main-darker;

#LayoutAuth {
  min-height: 100vh;

  > .Row {
    min-height: 100vh;
  }

  .LayoutAuth-side {
    align-items: flex-start;
    background: linear-gradient(189deg, $_hero-gradient-start, $_hero-gradient-end);
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 100vh;
    min-height: 100%;
    overflow: hidden;
    position: relative;

    .MainLogo {
      left: 2rem;
      position: absolute;
      top: 1.5rem;
    }

    .description {
      color: $text-color-light;
      @include lg {
        margin-bottom: 20vh;
      }
      @include xl {
        margin-bottom: 40vh;
      }

      p {
        margin-bottom: 1rem;
      }
    }

    .banner {
      bottom: 0;
      display: none;
      height: 100%;
      pointer-events: none;
      position: absolute;
      width: 100%;
      @include lg {
        display: block;
      }

      img {
        flex-shrink: 0;
        max-width: 100%;
        min-height: 100%;
        object-fit: cover;
        @include xl {
          max-width: none;
          min-width: 100%;
        }
      }
    }
  }

  .LayoutAuth-container {
    align-items: center;
    background: $white;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: center;

    > .MainLogo {
      margin-top: 2rem;
    }

    > .view-container {
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      justify-content: center;
      width: 100%;
    }
  }
}

</style>
